import { type FC } from 'react'

import { RowSelectButton } from './row-select-button'

interface Props {
  disabled?: boolean
  className?: string
  checked: boolean
  onClick: () => void
}

export const CellContentSelectRow: FC<Props> = ({ disabled = false, checked, onClick }) => {
  return <RowSelectButton disabled={disabled} checked={checked} onClick={onClick} />
}
